import {
  callApiLayDanhSachTinhThanh,
  callApiLayThemTinhThanh,
  callApiXoaTinhThanh,
  callApiSuaTinhThanh,
  callApiLayDanhSachTinhThanhTrongVung,
  callApiLayDanhSachTinhThanhFree
} from "@/api/dm-tinh-thanh";
import { showMsgOk, showMsgError } from "@/utils/commonUtils";

const layDanhSachTinhThanh = async ({ commit }, payload) => {
  const response = await callApiLayDanhSachTinhThanh(payload);
  if (response && response.data.succeeded) {
    if (payload.onSuccess) {
      payload.onSuccess(response.data.data)
    } else {
      commit("LAY_DANH_SACH_TINH_THANH_THANH_CONG", response.data.data);
    }
  }
};

const themTinhThanh = async (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayThemTinhThanh(payload.data)
      .then(res => {
        payload.onSuccess(res.data.data)
        showMsgOk(payload.message);
        resolve(res);
      })
      .catch(error => {
        showMsgError(error.response.data.message);
        reject(error);
      });
  });
};

const xoaTinhThanh = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiXoaTinhThanh(payload.data)
      .then(res => {
        resolve(res);
      })
      .catch(error => {
        showMsgError(error.response.data.message);
        reject(error);
      });
  });
};

const suaTinhThanh = async (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiSuaTinhThanh(payload.data)
      .then(res => {
        payload.onSuccess(res.data.data)
        showMsgOk(payload.message);
        resolve(res);
      })
      .catch(error => {
        showMsgError(error.response.data.message);
        reject(error);
      });
  });
};

const layDanhSachTinhThanhTrongVung = async ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayDanhSachTinhThanhTrongVung(payload)
      .then(res => {
        commit("LAY_DANH_SACH_TINH_THANH_TRONG_VUNG_THANH_CONG", res.data.data);
        resolve(res);
      })
      .catch(error => {
        showMsgError(error.response.data.message);
        reject(error);
      });
  });
};

const layDanhSachTinhThanhFree = async ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayDanhSachTinhThanhFree(payload)
      .then(res => {
        commit("LAY_DANH_SACH_TINH_THANH_FREE_THANH_CONG", res.data.data);
        resolve(res);
      })
      .catch(error => {
        showMsgError(error.response.data.message);
        reject(error);
      });
  });

};

export default {
  layDanhSachTinhThanh,
  themTinhThanh,
  xoaTinhThanh,
  suaTinhThanh,
  layDanhSachTinhThanhTrongVung,
  layDanhSachTinhThanhFree
};
